import { Component, Input } from '@angular/core';

@Component({
  selector: 'layout-box',
  template: require('./layout-box.component.html'),
  styles: [require('./layout-box.component.scss')],  
})

export class LayoutBoxComponent {};



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/layout-box/layout-box.component.ts